export const LANGUAGES = [
  {
    code: "VI",
    value: "vi",
    label: "Tiếng Việt",
    flag: "https://flagcdn.com/w40/vn.png",
  },
  {
    code: "EN",
    value: "en",
    label: "English",
    flag: "https://flagcdn.com/w40/gb.png",
  },
];
